import { Translator } from "../../../../../docz/components";
import React from 'react';
export default {
  Translator,
  React
};